import { ActionKeys } from './constants';

export type DialogType = 'success' | 'error' | 'default';

export interface ShowDialogProps {
  messages: string[];
  title?: string;
  confirmButtonText?: string;
  closeButtonText: string;
}

export function showDialog(props: ShowDialogProps, dialogType: DialogType) {
  return <const>{
    payload: {
      props,
      dialogType,
    },
    type: ActionKeys.DIALOG_SHOW,
  };
}

export function hideDialog() {
  return <const>{
    type: ActionKeys.DIALOG_HIDE,
  };
}

export type DialogActions = ReturnType<typeof showDialog> | ReturnType<typeof hideDialog>;
